(() => {
  const script = document.currentScript;
  const section = document.querySelector(`[data-section-id="${CSS.escape(script.dataset.filterSection)}"]`);
  if (!section || section.dataset.stableFiltersBound) return;
  section.dataset.stableFiltersBound = 'true';
  const customSelector = '[data-slide-constraint-filter]';
  const dimensions = ['type', 'tent', 'lane', 'height', 'length'];
  const typeTags = new Set([
    'christmas-bounce-house', 'christmas-inflatable-snow-globe', 'christmas-inflatable-slide',
    'christmas-obstacle-course', 'christmas-inflatable-maze', 'christmas-mechanical-game',
    'is-halloween-bounce-house', 'is-halloween-inflatable-slide', 'is-halloween-obstacle-course',
    'is-halloween-maze', 'is-halloween-snow-globe', 'is-halloween-mechanical-game',
    'is-white-nightclub', 'is-black-nightclub', 'is-silver-nightclub',
    'is-bounce-house', 'is-bounce-house-with-slide', 'is-white-bounce-house', 'is-pastel-bounce-house',
    'is-white-bouncer', 'is-white-bouncer-with-slide', 'is-mechanical-bull', 'is-meltdown',
    'is-bungee', 'is-surf-simulator', 'is-inflatable-water-slide', 'is-inflatable-dry-slide',
    'is-inflatable-pool-slide', 'is-inflatable-slip-and-slide'
  ]);
  let navigationTimer;

  function dimensionForTag(tag) {
    if (typeTags.has(tag)) return 'type';
    if (['single-lane', 'double-lane', 'triple-lane'].includes(tag)) return 'lane';
    if (['is-cube-tent', 'is-dome-tent', 'is-party-tent'].includes(tag)) return 'tent';
    if (/^\d+ft$/.test(tag)) return 'height';
    if (/^length-\d+ft$/.test(tag)) return 'length';
    return '';
  }

  function normalizedTag(value) {
    return value.trim().toLowerCase().replace(/\s+/g, '-');
  }

  function stateFor(url) {
    const state = {};
    const tokens = (url.searchParams.get('constraint') || '').split(/[+ ]+/).filter(Boolean);
    url.searchParams.getAll('filter.p.tag').forEach(tag => {
      const normalized = normalizedTag(tag);
      if (dimensionForTag(normalized)) tokens.push(normalized);
    });
    tokens.forEach(token => {
      const tag = normalizedTag(token);
      const dimension = dimensionForTag(tag);
      if (dimension) state[dimension] = tag;
    });
    return state;
  }

  function writeState(url, state) {
    const unknown = (url.searchParams.get('constraint') || '').split(/[+ ]+/)
      .filter(tag => tag && !dimensionForTag(normalizedTag(tag)));
    const nativeTags = url.searchParams.getAll('filter.p.tag')
      .filter(tag => !dimensionForTag(normalizedTag(tag)));
    url.searchParams.delete('filter.p.tag');
    nativeTags.forEach(tag => url.searchParams.append('filter.p.tag', tag));
    const tags = [...unknown, ...dimensions.map(dimension => state[dimension]).filter(Boolean)];
    url.searchParams.delete('constraint');
    if (tags.length) url.searchParams.set('constraint', [...new Set(tags)].join('+'));
  }

  function navigate(url, delay = 0) {
    url.searchParams.delete('page');
    clearTimeout(navigationTimer);
    navigationTimer = setTimeout(() => window.location.assign(url.href), delay);
  }

  function applyState() {
    const url = new URL(window.location.href);
    const state = stateFor(url);
    // This cache belongs only to this URL snapshot, including pageshow restoration.
    const valuesByName = new Map();
    section.querySelectorAll(customSelector).forEach(input => {
      input.checked = (state[input.dataset.slideFilterDimension] || '') === input.dataset.slideFilterTag;
    });
    section.querySelectorAll('input[data-filter-item-input]:not([data-slide-constraint-filter])').forEach(input => {
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.name.startsWith('filter.')) {
          if (!valuesByName.has(input.name)) valuesByName.set(input.name, url.searchParams.getAll(input.name));
          input.checked = valuesByName.get(input.name).includes(input.value);
        }
        if (input.name === 'sort_by') input.checked = input.value === (url.searchParams.get('sort_by') || section.dataset.defaultSort);
      }
    });
    section.querySelectorAll('[data-filter-group]').forEach(group => {
      const custom = group.querySelector(customSelector);
      const active = custom ? Boolean(state[custom.dataset.slideFilterDimension]) :
        [...group.querySelectorAll('input[name^="filter."]')].some(input =>
          input.type === 'checkbox' || input.type === 'radio' ? input.checked : Boolean(url.searchParams.get(input.name)));
      group.dataset.filterGroupHasActiveFilters = String(active);
      group.querySelectorAll('[data-filter-group-clear]').forEach(reset => { reset.dataset.hasActiveFilters = String(active); });
      const activeLabels = group.querySelectorAll('.filter-form__group-toggle-active-values');
      if (activeLabels.length) {
        const activeText = [...group.querySelectorAll('input:checked')].map(input =>
          input.closest('label')?.querySelector('.filter-item__label')?.textContent.trim() || input.value).join(', ');
        activeLabels.forEach(label => { label.textContent = activeText; });
      }
    });
    const activeKeys = new Set();
    url.searchParams.forEach((value, key) => {
      if (key.startsWith('filter.') && value) activeKeys.add(key.startsWith('filter.v.price.') ? 'price' : `${key}:${value}`);
    });
    dimensions.forEach(dimension => { if (state[dimension]) activeKeys.add(`constraint:${state[dimension]}`); });
    section.querySelectorAll('.filter-topbar__drawer-toggle-text__count').forEach(count => {
      count.textContent = `(${activeKeys.size})`;
      count.dataset.hasActiveFilters = String(activeKeys.size > 0);
    });
    section.querySelectorAll('.filter-form').forEach(form => { form.dataset.filtersActive = String(activeKeys.size > 0); });
  }

  document.addEventListener('change', event => {
    const input = event.target.closest('input, select');
    if (!input || (!section.contains(input) && !input.matches('[data-sort-item-input]'))) return;
    if (!input.matches('[data-filter-item-input], [data-sort-item-input], [data-range-input]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const url = new URL(window.location.href);
    const state = stateFor(url);
    if (input.matches(customSelector)) {
      state[input.dataset.slideFilterDimension] = input.dataset.slideFilterTag;
    } else if (input.name === 'sort_by') {
      url.searchParams.set('sort_by', input.value);
    } else if (input.matches('[data-range-input]')) {
      const priceGroup = input.closest('[data-filter-group]');
      (priceGroup || input.closest('form')).querySelectorAll('[data-range-input]').forEach(range => {
        url.searchParams.delete(range.name);
        if (range.value !== '') url.searchParams.set(range.name, range.value);
      });
    } else if (input.name.startsWith('filter.')) {
      url.searchParams.delete(input.name);
      const form = input.closest('form');
      const peers = form ? [...form.querySelectorAll('input, select')].filter(peer => peer.name === input.name) : [input];
      peers.forEach(peer => {
        if (((peer.type === 'checkbox' || peer.type === 'radio') ? peer.checked : peer.value !== '') && !peer.disabled) {
          url.searchParams.append(peer.name, peer.value);
        }
      });
    } else return;
    writeState(url, state);
    navigate(url, input.matches('[data-range-input]') ? 300 : 0);
  }, true);

  document.addEventListener('click', event => {
    const control = event.target.closest('[data-filter-group-clear], [data-clear-all-filters], [data-remove-filter], [data-remove-range], [data-filter-group-toggle], [data-filter-truncate-toggle], [data-filter-search-clear]');
    if (!control || !section.contains(control)) return;
    const url = new URL(window.location.href);
    const state = stateFor(url);
    const group = control.closest('[data-filter-group]');
    event.preventDefault();
    event.stopImmediatePropagation();
    if (control.matches('[data-filter-search-clear]')) {
      const search = group?.querySelector('[data-filter-search-input]');
      if (search) { search.value = ''; filterSearch(search); }
      return;
    }
    if (control.matches('[data-filter-truncate-toggle]')) {
      const expanded = control.dataset.isTruncated === 'true';
      group.querySelectorAll('[data-filter-item-should-truncate="true"]').forEach(item => {
        item.dataset.filterItemIsTruncated = String(!expanded);
      });
      control.dataset.isTruncated = String(!expanded);
      control.setAttribute('aria-expanded', String(expanded));
      const label = control.querySelector('[data-truncate-toggle-text]');
      if (label) label.textContent = control.getAttribute(expanded ? 'data-show-less-text' : 'data-show-more-text');
      return;
    }
    if (control.matches('[data-filter-group-toggle]')) {
      const panel = section.querySelector(`#${CSS.escape(control.getAttribute('aria-controls'))}`);
      if (panel) {
        const expanded = control.getAttribute('aria-expanded') !== 'true';
        control.setAttribute('aria-expanded', String(expanded));
        panel.setAttribute('aria-hidden', String(!expanded));
        panel.style.height = expanded ? 'auto' : '0px';
        panel.style.overflow = expanded ? '' : 'hidden';
      }
      return;
    }
    if (control.matches('[data-clear-all-filters]')) {
      [...url.searchParams.keys()].forEach(key => { if (key.startsWith('filter.') || key === 'constraint') url.searchParams.delete(key); });
      dimensions.forEach(dimension => { delete state[dimension]; });
    } else if (control.matches('[data-remove-filter]')) {
      const removedDimension = dimensionForTag(normalizedTag(control.dataset.value || ''));
      if (control.dataset.name === 'filter.p.tag' && removedDimension) delete state[removedDimension];
      const name = control.dataset.name;
      const values = url.searchParams.getAll(name).filter(value => value !== control.dataset.value);
      url.searchParams.delete(name);
      values.forEach(value => url.searchParams.append(name, value));
    } else if (control.matches('[data-remove-range]')) {
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
    } else if (group) {
      const custom = group.querySelector(customSelector);
      if (custom) delete state[custom.dataset.slideFilterDimension];
      else group.querySelectorAll('[name^="filter."]').forEach(input => url.searchParams.delete(input.name));
    }
    writeState(url, state);
    navigate(url);
  }, true);

  function filterSearch(input) {
    const group = input.closest('[data-filter-group]');
    const query = input.value.trim().toLowerCase();
    let matches = 0;
    group.querySelectorAll('[data-filter-list-item]').forEach(item => {
      const match = item.dataset.itemLabel.toLowerCase().includes(query);
      const matchValue = String(match);
      if (item.dataset.filterItemSearchMatch !== matchValue) item.dataset.filterItemSearchMatch = matchValue;
      if (match) matches += 1;
    });
    const activeValue = String(Boolean(query));
    const emptyValue = String(Boolean(query) && matches === 0);
    if (group.dataset.filterSearchActive !== activeValue) group.dataset.filterSearchActive = activeValue;
    if (group.dataset.filterSearchEmpty !== emptyValue) group.dataset.filterSearchEmpty = emptyValue;
  }

  ['input', 'keyup'].forEach(name => document.addEventListener(name, event => {
    if (section.contains(event.target) && event.target.matches('[data-filter-search-input]')) {
      event.stopImmediatePropagation();
      filterSearch(event.target);
    }
  }, true));

  try {
    Object.keys(sessionStorage).forEach(key => {
      if (/^collection-(height|length)-options:/.test(key)) sessionStorage.removeItem(key);
    });
  } catch (error) {}
  applyState();
  section.dataset.filterOptionsReady = 'true';
  window.addEventListener('pageshow', event => {
    if (event.persisted) applyState();
  });
})();
